module.exports = __webpack_public_path__ + "static/home-image.fab10b35.svg";